import { MonitorWeight, Watch } from "@material-symbols-svg/react";
import { Droplets } from "lucide-react";
import { DeviceGroup } from "src/types/device.types";
import goodflipSmartScaleImg from "src/assets/images/devices/goodflip-smart-scale.png";
import goodflipCgmReaderImg from "src/assets/images/devices/goodflip-cgm-reader.png";

export const DEVICE_GROUPS: DeviceGroup[] = [
  {
    id: "scales",
    title: "Scales",
    description: "Weight and body composition",
    devices: [
      {
        id: "goodflip-smart-scale",
        name: "GoodFlip Smart Scale",
        description: "Body composition + app sync",
      },
    ],
  },
  {
    id: "glucose",
    title: "Glucose Monitoring",
    description: "Track blood sugar readings",
    devices: [
      {
        id: "goodflip-cgm-reader",
        name: "GoodFlip CGM Reader",
        description: "Sync with GoodFlip CGM Reader",
      },
    ],
  },
];

export const DEVICE_GROUPS_ICONS: Record<
  string,
  { icon: React.ReactNode; iconBg: string }
> = {
  scales: {
    icon: <MonitorWeight className="w-5 h-5 text-[var(--app-primary)]" />,
    iconBg: "bg-green-100",
  },
  glucose: {
    icon: <Droplets className="w-5 h-5 text-[var(--app-primary)]" />,
    iconBg: "bg-blue-100",
  },
};

export const DEVICE_ICONS: Record<
  string,
  { icon: React.ReactNode; iconBg: string }
> = {
  "goodflip-smart-scale": {
    icon: <MonitorWeight className="w-5 h-5 text-[var(--app-primary)]" />,
    iconBg: "bg-green-100",
  },
  "goodflip-cgm-reader": {
    icon: <Watch className="w-5 h-5 text-[var(--app-primary)]" />,
    iconBg: "bg-blue-100",
  },
};

export const DEVICE_IMAGES: Record<string, { image: string }> = {
  "goodflip-smart-scale": {
    image: goodflipSmartScaleImg,
  },
  "goodflip-cgm-reader": {
    image: goodflipCgmReaderImg,
  },
};

export const CONNECTED_DEVICES = [
  {
    id: "goodflip-smart-scale",
    name: "GoodFlip Smart Scale",
    description: "Body composition + app sync",
  },
];
